import { render } from "./FormsPage.vue?vue&type=template&id=c701abc4"
import script from "./FormsPage.vue?vue&type=script&lang=js"
export * from "./FormsPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__